module.exports = __webpack_public_path__ + "img/m-banner-vbrohihj-vi-VN.2c70fc35.jpg";